import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import Iconify from '../../../components/iconify';
import { MenuItem } from '@mui/material';
import GameTypeForm from './GameTypeForm';
import api from 'src/api';
import { loadingStartAction, loadingStopAction } from 'src/redux/actions/loadingActions';
import { useDispatch } from 'react-redux';

// Single Digit 1
// Jodi Digit 2
// Single Panna 3
// Double Panna 4
// Triple Panna 5
// Half Sangam 6
// Full Sangam 7

let gameTypeData = [
  {
    name: 'Single Digit',
    id: 1,
  },
  {
    name: 'Jodi Digit',
    id: 3,
  },

  {
    name: ' Single Panna ',
    id: 3,
  },
  {
    name: 'Triple Panna',
    id: 4,
  },
  {
    name: ' Double Panna ',
    id: 5,
  },

  {
    name: 'Half Sangam',
    id: 6,
  },
  {
    name: 'Full Sangam',
    id: 7,
  },
];

export default function CreateAndUpdateGameTypeModal({ selectedGame,data }) {
  const [open, setOpen] = React.useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const dispatch = useDispatch();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const createAllAtOnes = async () => {
    dispatch(loadingStartAction());
    // const response = await api.get('/game-types');
    // let createRes = []
    // if (response.data.results?.length === 0) {
    //   for (let index = 0; index < gameTypeData.length; index++) {
    //     const reqBody = {
    //       game_type_name: gameTypeData[index].name,
    //       game_type_unique_id: gameTypeData[index].id,
    //       is_active: true,
    //     };

    //     createRes.push(await api.put(`/game-types/${gameTypeData[index].id}`, reqBody))
    //   }
    // } else {
    //   alert('Please delete all and then retry!');
    // }

    // Promise.all(createRes)

    dispatch(loadingStopAction());

  };

  return (
    <div>
  {/* {!selectedGame && data.length === 0  &&    <Button
        onClick={createAllAtOnes}
        variant="contained"
        color="error"
        style={{
          marginRight: 10,
        }}
      >
        Create All Types
      </Button>} */}
      {selectedGame ? (
        <MenuItem onClick={handleClickOpen}>
          <Iconify icon={'eva:edit-fill'} sx={{ mr: 2 }} />
          Edit
        </MenuItem>
      ) : (
        <Button onClick={handleClickOpen} variant="contained" startIcon={<Iconify icon="eva:plus-fill" />}>
          New Game Type
        </Button>
      )}
      <Dialog fullScreen={fullScreen} open={open} onClose={handleClose} aria-labelledby="responsive-dialog-title">
        <DialogTitle id="responsive-dialog-title">
          {selectedGame ? 'Update Game Type' : 'Add New Game Type'}
        </DialogTitle>
        <DialogContent>
          <GameTypeForm handleClose={handleClose} selectedGame={selectedGame} />
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose}>
            Skip Now
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
